import { Button } from "@/components/ui/button";
import { useState } from 'react';

import ErrorPopup from '@/components/custom/InfoPopups/ErrorPopup';
import SuccessPopup from "@/components/custom/InfoPopups/SuccessPopup";
import LoaderWithBackdrop from '@/components/custom/LoaderWithBackdrop';
import { useProjectStore } from "@/lib/zustand/useStore";

import DecisionModal from '@/components/custom/InfoPopups/DecisionModal';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { removeUserFromProject } from '@/lib/supabase/queries';
import AddSolverModal from './AddSolverModal';
import { useInviteUserToProject } from "@/features/project/hooks/useMutation/useInviteUserToProject";
import { CheckProjectAccess } from '@/features/rbac/components/molecules/CheckProjectAccess';
import { BadgeCheck, BadgeX, UserMinus } from 'lucide-react';

export function ProjectMembers() {
    const { project } = useProjectStore();
    const [showAddUserModal, setShowAddUserModal] = useState<boolean>(false);
    /* 
    * Get Remaining Height for the ScrollArea
    * This is used to calculate the height of the scroll area based on the available space in the container.
    * Can be used in both columns using only Left/Right as a reference.
    */
    /*  
    * Handle Right Column ScrollArea
    */

    const { isPending: isPendingInviteUserToProject, mutateAsync: inviteUserToProject } = useInviteUserToProject();

    const onAddSolver = async (data: { email: string }) => {
        if (!project) return;
        const res = await inviteUserToProject({
            projectId: project.id,
            invitedUserEmail: data.email
        })
        console.log(res)
        if (res?.data?.message) {
            SuccessPopup(res.data.message);
            setShowAddUserModal(false);
        }
        if (res.data.error) {
            ErrorPopup(res.data.error);
        }
    };

    const removeMemberHandler = async (project_id: string | undefined, user_id: string) => {
        if (!project_id) return;

        const userDecision = await DecisionModal({ title: "Remove solver", confirmButtonText: "Remove", message: 'Do you really want to remove this solver from the project?' });
        if (!userDecision.isConfirmed) return;

        try {
            await removeUserFromProject(project_id, user_id);
            SuccessPopup("Survey restored successfully");
        } catch (error) {
            ErrorPopup("Error restoring survey");
        }
    };

    return (
        <>
            {(isPendingInviteUserToProject) && (<LoaderWithBackdrop />)}

            <AddSolverModal
                modalOpen={showAddUserModal}
                setModalOpen={setShowAddUserModal}
                onSubmitHandler={onAddSolver}
            />

            <div className="flex items-stretch flex-1 gap-4">

                <div className="flex flex-col flex-1">
                    <div className="flex flex-col flex-1 gap-2">

                        <div className="flex justify-between">
                            <div className="flex items-center">
                                <p className="mb-2 text-xs">Project Solvers</p>
                            </div>

                            <div className="flex justify-center gap-2">

                                <Button className="ml-auto" size="sm" onClick={() => setShowAddUserModal(true)}>
                                    Add Member
                                </Button>
                            </div>
                        </div>

                        {(() => {


                            return (
                                <>
                                    {(project?.project_members?.length === 0) ? (
                                        <div className="grid h-full place-items-center">
                                            <p>No members found</p>
                                        </div>
                                    ) : (
                                        <ScrollArea className="pe-4" type="always" style={{ height: 'calc(100vh - 174px)' }}>
                                            <div className="flex flex-col gap-2">
                                                <div className="flex flex-col gap-2 ">
                                                    {project?.project_members?.map((member => {
                                                        if (!member) return null;

                                                        return (
                                                            <div key={member.user_id} className="flex items-center justify-between gap-2 p-2 bg-gray-100 rounded-md">
                                                                <div className="w-full">
                                                                    <div className="flex items-center gap-1">
                                                                        <TooltipProvider>
                                                                            <div className="flex justify-center gap-1">
                                                                                <Tooltip>
                                                                                    <TooltipTrigger asChild>
                                                                                        {member.user?.signed_up ? (
                                                                                            <BadgeCheck size={16} className="text-green-500" />
                                                                                        ) : (
                                                                                            <BadgeX size={16} className="text-red-500" />
                                                                                        )}
                                                                                    </TooltipTrigger>
                                                                                    <TooltipContent>
                                                                                        {member.user?.signed_up ? "User signed up" : "User not signed up"}
                                                                                    </TooltipContent>
                                                                                </Tooltip>
                                                                            </div>
                                                                        </TooltipProvider>
                                                                        <p>
                                                                            {member.user?.first_name} {member.user?.last_name}
                                                                            {!member.user?.first_name && "User haven't provided name"}
                                                                        </p>
                                                                    </div>
                                                                    <p className="text-xs">
                                                                        <b>Email:</b> {member.user?.email || "-"}
                                                                    </p>
                                                                    <p className="text-xs">
                                                                        <b>Role:</b> {member.role?.label  || "-"}
                                                                    </p>
                                                                </div>

                                                                <CheckProjectAccess project_remove_member>
                                                                    <TooltipProvider>
                                                                        <div className="flex justify-center gap-1">
                                                                            <Tooltip>
                                                                                <TooltipTrigger asChild>
                                                                                    <Button
                                                                                        variant="destructive"
                                                                                        size='action'
                                                                                        onClick={() => removeMemberHandler(project?.id, member.id)}
                                                                                    >
                                                                                        <UserMinus size={16} />
                                                                                    </Button>
                                                                                </TooltipTrigger>
                                                                                <TooltipContent>
                                                                                    Remove Member
                                                                                </TooltipContent>
                                                                            </Tooltip>
                                                                        </div>
                                                                    </TooltipProvider>
                                                                </CheckProjectAccess>
                                                            </div>
                                                        )

                                                    }))}
                                                </div>
                                            </div>
                                        </ScrollArea>
                                    )}
                                </>
                            )
                        })()}
                    </div>
                </div>
            </div>
        </>
    )
}

